export const CONFIG_LOAD_FILE = 'CONFIG_LOAD_FILE'
export const CONFIG_SET = 'CONFIG_SET'

export const EVENT_LOAD_CALENDARS = 'EVENT_LOAD_CALENDARS'
export const EVENT_CALCULATE = 'EVENT_CALCULATE'
export const EVENT_REMOVE_EXPIRED = 'EVENT_REMOVE_EXPIRED'
